module.exports = __webpack_public_path__ + "img/sv20.3df9d319.svg";